import { render, staticRenderFns } from "./SelectMethod.vue?vue&type=template&id=32136b0c&scoped=true&"
import script from "./SelectMethod.vue?vue&type=script&lang=js&"
export * from "./SelectMethod.vue?vue&type=script&lang=js&"
import style0 from "./SelectMethod.vue?vue&type=style&index=0&id=32136b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32136b0c",
  null
  
)

export default component.exports